import { Profile2User } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { StatisticCard } from '../../atoms/StatisticCard';
import { useGetSubscriptionStatsQuery } from '@/store/services/reports';
import { useReportPeriod } from '@/store/slices/reportFiltersSlice';

export function Stats() {
  const { t } = useTranslation();
  const period = useReportPeriod();
  const { data: statisticsData } = useGetSubscriptionStatsQuery(
    period ? { period } : undefined,
    { skip: !period }
  );

  return (
    <div className="space-y-6">
      <div className={`col-span-2 grid gap-6 grid-cols-1 md:grid-cols-4`}>
        {Object.entries(statisticsData?.payload || {}).map(([key, value]) => (
          <StatisticCard
            key={key}
            title={t(
              `reports.subscription.${key}`,
              t(`reports.subscriptions.${key}`, key)
            )}
            value={value as string | number}
            Icon={Profile2User}
            postfix="user"
          />
        ))}
      </div>
    </div>
  );
}
